import { render } from "./PopUpBlock.vue?vue&type=template&id=6ed95708&scoped=true"
import script from "./PopUpBlock.vue?vue&type=script&lang=js"
export * from "./PopUpBlock.vue?vue&type=script&lang=js"

import "./PopUpBlock.vue?vue&type=style&index=0&id=6ed95708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed95708"]])

export default __exports__